import { z } from "zod";

import { communityAssignmentCompletionSchema } from "./communityAssignmentCompletionSchema";

export const communityAssignmentCompletionsSchema = z.object({
  results: z.array(communityAssignmentCompletionSchema),
  total: z.number(),
});
